<template>
  <svg width="35" height="26" viewBox="0 0 35 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M35 5.16555V8.80276H29.9652V13.9112H26.1729V8.80276H21.1705V5.15736H26.1729V-0.00830078H29.9652V5.15736L35 5.16555ZM13.3179 5.16555V17.009C13.3179 20.2784 11.6937 21.9131 8.96519 21.9131C6.23665 21.9131 4.62064 20.2784 4.62064 17.009V5.19007H0V17.1071C0 23.5723 3.41879 25.9999 8.80278 25.9999H9.13573C14.5197 25.9999 17.9385 23.5478 17.9385 17.1071V5.19007L13.3179 5.16555Z" fill="#AAAAAA"/>
</svg>

</template>